import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import routes from './routes';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { loginData } from './store/account/userActions';
import './scss/style.scss'
import './scss/examples.scss'
import UserRoute from './routes/UserRoute';
import { LanguageProvider } from './context/LanguageContext';
import { useTranslation } from './hooks/useTranslation';

const keys = Object.keys(routes);

const initializeLanguage = () => {
  if (!localStorage.getItem('language')) {
    const browserLanguage = navigator.language.toLowerCase();
    const defaultLanguage = browserLanguage.startsWith('tr') ? 'tr' : 'en';
    localStorage.setItem('language', defaultLanguage);
    console.log('Language initialized:', defaultLanguage);
  }
};

initializeLanguage();

function App({ ...props }) {
  const { setLoginData } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const initializeAuth = () => {
      try {
        const userData = localStorage.getItem('user');
        const token = localStorage.getItem('token');
        
        // console.log('Stored userData:', userData);
        // console.log('Stored token:', token);

        if (userData && token) {
          const parsedUserData = JSON.parse(userData);
          // console.log('Parsed user data:', parsedUserData);
          
          if (parsedUserData.user) {
            setLoginData(parsedUserData.user);
          } else if (parsedUserData.id) {
            setLoginData(parsedUserData);
          }
          
          setIsAuthenticated(true);
        } else {
          console.log('No user data or token found');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error initializing auth:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, [setLoginData]);

  useEffect(() => {
    if (props.user) {
      setIsAuthenticated(true);
    }
  }, [props.user]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        {t('loading')}
      </div>
    );
  }

  const checkAuthentication = () => {
    if (props.user) return true;
    
    const userData = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    return userData && token;
  };

  const userIsAuthenticated = checkAuthentication();

  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={userIsAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />}
          />
          
          {keys.map((layoutName) => {
            const layout = routes[layoutName];
            return routes[layoutName].children.map((route, index) => {
              if (route.path === '/login' && userIsAuthenticated) {
                return (
                  <Route
                    key={`${layoutName}-${index}`}
                    path={route.path}
                    element={<Navigate to="/home" />}
                  />
                );
              }
              
              if (route.routeComponent === UserRoute && !userIsAuthenticated) {
                return (
                  <Route
                    key={`${layoutName}-${index}`}
                    path={route.path}
                    element={<Navigate to="/login" />}
                  />
                );
              }
              
              const RouteWrapper = (props) => (
                <layout.component {...props}>
                  <route.component {...props} />
                </layout.component>
              );
              
              return (
                <Route
                  key={`${layoutName}-${index}`}
                  exact={route.exact}
                  path={route.path}
                  element={<RouteWrapper />}
                />
              );
            });
          })}
          
          <Route
            path="*"
            element={
              userIsAuthenticated ? (
                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '50px',
                  fontSize: '24px'
                }}>
                  {t('pageNotFound')}
                </div>
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
  };
};

const mapDispatchToProps = {
  setLoginData: loginData,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);